import Checkout from './checkout';
import CashbackEarnedModal from './CashbackEarnedModal';
import CompanyDetailsModal from './CompanyDetailsModal';
import MenuItemsModal from './MenuItemsModal';
import MultiPromoCodeModal from './MultiPromoCodeModal';
import NutritionInfo from './NutritionInfo';
import OtpVerificationModal from './OtpVerificationModal';
import LoginModal from './LoginModal';
import RewardsUnlockedModal from './RewardsUnlockedModal';
import PointsEarnedModal from './PointsEarnedModal';
import FreeProductsModal from './FreeProductsModal';
import MenuItemModal from './MenuItemModal';
import OrderMethod from './order-method';
import Marketing from './marketing';
import RestaurantClosed from './restaurant-closed';
import OrderBasket from './order-basket';
import OfferModal from './OfferModal';
import FreeItemsModal from './FreeItemsModal';
import EligibleOffersModal from './EligibleOffersModal';
import MobileAppSignupBonusModal from './MobileAppSignupBonusModal';

export default {
  Checkout,
  CashbackEarnedModal,
  CompanyDetailsModal,
  MenuItemsModal,
  MultiPromoCodeModal,
  OrderMethod,
  NutritionInfo,
  OtpVerificationModal,
  LoginModal,
  RewardsUnlockedModal,
  PointsEarnedModal,
  FreeProductsModal,
  MenuItemModal,
  Marketing,
  RestaurantClosed,
  OrderBasket,
  OfferModal,
  FreeItemsModal,
  EligibleOffersModal,
  MobileAppSignupBonusModal,
};
